<template>
  <div class="flex size-full flex-col px-3 text-gray-700 md:p-0">
    <p class="text-left text-xl md:text-2xl">
      <span class="font-serif">Hola {{ sessionStore.user?.firstName || 'Vico' }},</span>
      <span class="text-center font-light"> ¿Dónde vendes tus productos? </span>
    </p>
    <form
      class="flex w-full flex-col"
      @submit.prevent="onSubmit"
    >
      <div class="mt-5 flex w-full flex-col md:mt-8">
        <button
          v-for="option in shopKindOptions"
          :key="option.id"
          type="button"
          class="mt-2 flex items-center rounded-md border border-gray-300 p-3 first:mt-0"
          :class="{ 'border-gray-700': option.id === selectedShopKind.id }"
          @click="(selectedShopKind = option)"
        >
          <div class="w-full rounded-md text-left text-sm text-gray-700 md:text-base">
            <p class="">
              {{ option.name }}
            </p>
            <p
              v-if="option.description"
              class="text-xs font-light text-gray-500 md:text-sm"
            >
              {{ option.description }}
            </p>
          </div>
          <div
            class="ml-auto flex size-4 items-center justify-center border border-gray-300"
            :class="{ 'border-gray-700 bg-gray-700': option.id === selectedShopKind.id }"
          >
            <CheckIcon class="size-3 text-white" />
          </div>
        </button>
        <custom-input
          v-if="selectedShopKind.id === 3"
          v-model="signUpStore.shopForm.otherKind"
          class="mt-3"
          name="shops[other_kind]"
          label="Otro tipo de tienda"
          placeholder="Otro tipo de tienda"
          :rules="{ required: true }"
        />
        <Field
          v-model="shopKind"
          class="w-full border p-2"
          name="shopKind"
          hidden
          type="string"
          label="Tipo de tienda"
          :rules="{ required: true }"
        />
      </div>
      <div class="mt-5 flex w-full flex-col items-center md:mt-8">
        <button
          class="w-full rounded-md bg-gray-700 p-2 text-sm text-white md:text-base"
          :class="{ 'opacity-80': !!errors?.shopKind, 'hover:bg-gray-800': !errors?.shopKind }"
          :disabled="!!errors?.shopKind"
        >
          Continuar
        </button>
        <ErrorMessage
          name="shopKind"
          class="text-xs text-red-500 md:text-sm"
        />
      </div>
    </form>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch, onMounted } from 'vue';
import { Field, ErrorMessage, useForm } from 'vee-validate';
import { CheckIcon } from '@heroicons/vue/24/solid';
import useSignUpStore from 'stores/sign-up-store';
import useSessionStore from 'stores/user-store';
import customInput from './shared/custom-input.vue';

const sessionStore = useSessionStore();
const signUpStore = useSignUpStore();

interface ShopKindOption {
  id: number;
  name: string;
  type: string;
  description: string;
}

const selectedShopKind = ref({} as ShopKindOption);
const shopKind = computed(() => selectedShopKind.value.type as string);
const shopKindOptions = ref([
  {
    id: 4,
    name: 'Tienda física y online',
    type: 'physical_and_online_store',
    description: 'Locación permanente y tienda online',
  },
  { id: 0, name: 'Tienda física', type: 'physical_store', description: 'Locación permanente' },
  { id: 1, name: 'Solo tienda online', type: 'online_store', description: 'Sitio web o redes sociales' },
  { id: 2, name: 'Consumo personal', type: 'personal_consumption', description: 'No permitido' },
  { id: 3, name: 'Otro', type: 'other' },
] as ShopKindOption[]);

watch(shopKind, (newKind) => {
  signUpStore.shopForm.kind = newKind;
  if (newKind !== 'other') {
    signUpStore.shopForm.otherKind = '';
  }
});

onMounted(() => {
  if (signUpStore.shopForm.kind) {
    selectedShopKind.value = shopKindOptions.value.find(
      (option) => option.type === signUpStore.shopForm.kind,
    ) as ShopKindOption;
  }
});

const { handleSubmit, errors } = useForm();
const onSubmit = handleSubmit(() => {
  signUpStore.currentStep = 'shop-name';
});
</script>
